import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/async';
// import { Link, NavLink } from 'react-router-dom';

// import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import Header from '../../components/Header';
import DebriefTabs from './debrief_tabs';

import CSVDrop from '../../components/CSVDrop';
import PlayersManager from '../../components/PlayersTable';
import CopyLink from '../../components/CopyLink';
import SimCard from '../../components/SimCard';
// import csv_template from '../../assets/simcase_csv_template.csv';

// Actions
import { gameActions } from '../../actions';

// Simulate list of mini digital activities
import apiCatalog from '../catalog/data';

const Form = () => {
  // State
  const [onboarding, setOnboarding] = useState(false);
  const [item, setItem] = useState(null);
  const [instructors, setInstructors] = useState([]);

  // Hooks
  const dispatch = useDispatch();
  const user = useSelector((state) => state.authentication.user);
  const game = useSelector((state) => state.game);
  const { t } = useTranslation();

  // Effects
  useEffect(() => {
    setOnboarding(true);
  }, []);

  useEffect(() => {
    // if (user.role === 'administrator') {
    //   hubGetUsers();
    // } else {
    //   setItem({ ...item, instructor: user._id });
    //   setInstructors([user]);
    // }

    setItem({ ...item, created_by: user?._id });
    setInstructors([instructorDataToOption(user)]);
  }, [user]);

  useEffect(() => {
    if (game?.data) {
      setItem(game.data);

      // If the game has an instructor, fetch their data
      const gameInstructorId = game?.data?.instructor;
      if (gameInstructorId) {
        hubGetUserById(gameInstructorId).then((instructor) => {
          setInstructors(instructor);
        });
      }
    }
  }, [game?.data]);

  // Methods
  const handleChange = (e) => {
    let newItem = { ...item };
    newItem[e.target.name] =
      e.target.name === 'players_text'
        ? e.target.value.replace(/\t/g, ', ')
        : e.target.value;
    newItem['changed'] = true;
    console.log(newItem);
    setItem(newItem);
  };

  const submit = () => {
    dispatch(gameActions.updateGame(item));
  };

  const launch = () => {
    dispatch(gameActions.launchGame(item));
  };

  const readCSV = (content) => {
    let newItem = { ...item };
    newItem.players_text = content;
    dispatch(gameActions.updateGame(newItem));
  };

  const sortByName = (a, b) => {
    const fullNameEmailA = `${a.name} ${a.lastname} ${a.email}`
      ?.trim()
      .toLowerCase();
    const fullNameEmailB = `${b.name} ${b.lastname} ${b.email}`
      ?.trim()
      .toLowerCase();
    if (fullNameEmailA < fullNameEmailB) return -1;
    if (fullNameEmailA > fullNameEmailB) return 1;
    return 0;
  };

  const instructorDataToOption = (i) => {
    if (!i) return null;

    // Map the data to the format required by react-select
    const name =
      i?.name?.length > 0 || i?.lastname?.length > 0
        ? `${i?.name} ${i?.lastname} (${i.email})`.trim()
        : i?.email;

    return {
      value: i._id,
      label: `${name}`?.trim(),
    };
  };

  const hubGetUserById = async (userId) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/hub/users?_id=${userId}`,
      {
        method: 'GET',
      }
    );
    const data = await response.json();
    const sortedData = data?.map(instructorDataToOption);
    return sortedData;
  };

  const hubGetFilteredUsers = async (inputValue = '') => {
    // Only proceed if inputValue is at least 3 characters long
    if (inputValue.length < 3) return [];

    // Define filters
    const queryString = `?role[]=instructor&role[]=administrator&email=${inputValue}`;
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/hub/users${queryString}`,
      {
        method: 'GET',
      }
    );
    const data = await response.json();

    const sortedData = data?.sort(sortByName)?.map(instructorDataToOption);
    setInstructors(sortedData);

    return sortedData;
  };

  // Logic
  const okPPG = item?.registered?.length % item?.ppg === 0 ? true : false;
  const isSaving = item?.status === 'saving' ? true : false;
  const isLaunched = item?.status === 'launched' ? true : false;
  const isDisabled = !okPPG || isLaunched ? true : false;
  const isInstructor = user?.role === 'instructor' ? true : false;

  // Get the current sim data
  const simId = item?.sim_id;
  const simData = apiCatalog.find((sim) => sim._id === parseInt(simId));

  // Instructor options
  // const instructorOpts = instructors
  //   .sort((a, b) => {
  //     if (a.name < b.name) return -1;
  //     if (a.name > b.name) return 1;
  //     return 0;
  //   })
  //   .map((i, ii) => {
  //     const name =
  //       i.name?.length > 0 && i.lastname?.length > 0
  //         ? `${i.name} ${i.lastname}`
  //         : i.email;
  //     return (
  //       <option
  //         key={`ins-${ii}`}
  //         onClick={handleChange}
  //         value={i._id}>{`${name} (${i.email})`}</option>
  //     );
  //   });

  // Validation
  if (!item) return <div>{t('Loading...')}</div>;
  // if (item?.status === 'launched')
  //   return <Navigate to={'/games/' + item?._id + '/players'} />;

  // console.log(instructors);
  // console.log(instructors.find((i) => i.value === item?.created_by));

  // Render
  return (
    <div className=''>
      <Header />

      <div className='d-flex align-items-end my-4'>
        <div className='me-auto'>
          {game.data && <DebriefTabs game_id={game.data._id} />}
        </div>
      </div>

      {/* <h2 className='d-flex mt-3 sec-title fs-3'>
        {t('Simulation Setup')}{' '}
        <div className='ms-auto' style={{ lineHeight: 1 }}>
          <button
            className='btn btn-outline-primary'
            onClick={submit}
            disabled={isDisabled}>
            {isSaving ? t('Saving') : t('Save')}
          </button>
          <button
            className={`btn btn${isLaunched ? '-' : '-outline-'}success ms-3`}
            onClick={launch}
            disabled={isDisabled}>
            {isLaunched ? t('Launched') : t('Launch')}
          </button>
        </div>
      </h2> */}

      <div className='row'>
        {/* Left Panel */}
        <div className='col-5'>
          {/* <label className='fs-5'>{t('Settings')} </label> */}
          <div className='card shadow'>
            <div className='card-body p-4'>
              {/* Sim Information */}
              <div className='mb-4'>
                {simData && <SimCard {...simData} disableButtons={true} />}
                {/* Admins: Select dropdown to specify the sim_id */}
                {user?.role === 'administrator' && (
                  <div className='form-group mt-2'>
                    <label>{t('Sim ID')}</label>
                    <div className='input-group input-group-lg mt-2'>
                      <input
                        name='sim_id'
                        className='form-control'
                        placeholder={t('Enter the sim ID')}
                        // disabled={isDisabled || isSaving}
                        value={item.sim_id || ''}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                )}
              </div>

              {/* Admins: Select dropdown to specify the access_type */}
              {user?.role === 'administrator' && (
                <div className='mb-4'>
                  <div className='form-group mt-2'>
                    <label>{t('Access Type')}</label>
                    <div className='input-group input-group-lg mt-2'>
                      <select
                        name='access_type'
                        className='form-control form-select'
                        value={item?.access_type}
                        onChange={handleChange}
                        // disabled={isDisabled || isSaving}
                      >
                        <option value='link'>{t('Link')}</option>
                        <option value='csv'>{t('CSV')}</option>
                      </select>
                    </div>
                  </div>
                </div>
              )}

              {/* Session Name */}
              <div className='mb-4'>
                <div className='form-group'>
                  <label>{t('Session Name')}</label>
                  <div className='input-group input-group-lg mt-2'>
                    <input
                      name='name'
                      className='form-control'
                      placeholder={t('Enter game name')}
                      disabled={isDisabled || isSaving}
                      value={item.name || ''}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              {/* Instructor */}
              <div className='mb-4'>
                <label>{t('Instructor')}</label>
                <div className='input-group input-group-lg mt-2'>
                  {/* <select
                    name='instructor'
                    className='form-control form-select'
                    value={item?.instructor}
                    onChange={handleChange}
                    disabled={user.role === 'instructor'}>
                    <option value=''>Select Instructor (Required)</option>
                    {instructorOpts}
                  </select> */}
                  <AsyncSelect
                    name='instructor'
                    classNamePrefix='react-select'
                    classNames={{
                      container: () => 'fs-5 w-100',
                      input: () => 'py-1',
                      control: () => 'px-2 border rounded-3',
                      indicatorSeparator: () => 'my-3',
                      menu: () => 'small',
                    }}
                    loadOptions={hubGetFilteredUsers}
                    onChange={(selectedOption) => {
                      setItem((prev) => ({
                        ...prev,
                        instructor: selectedOption?.value,
                      }));
                    }}
                    // options={instructors}
                    defaultOptions={instructors}
                    value={instructors?.find(
                      (i) => i?.value === item?.instructor
                    )}
                    placeholder='Search Instructor'
                    noOptionsMessage={() => 'No instructors found'}
                    isClearable
                    isSearchable
                    isDisabled={isDisabled || isSaving || isInstructor}
                  />
                </div>
              </div>

              {item.access_type === 'link' && (
                <div>
                  {/* Registration Link */}
                  <div className='mb-4'>
                    <label className='mb-2'>
                      {t('Invite players using this link')}
                    </label>
                    <CopyLink link={item.short_url} />
                  </div>

                  {/* Allowed domains for registration */}
                  <div className='mb-4'>
                    <label className='mb-2'>
                      {t('Allowed domains for registration')}
                    </label>
                    <input
                      type='text'
                      name='allowed_domains'
                      placeholder={t(
                        'Example: domain1.com, domain2.com (leave empty to allow all domains)'
                      )}
                      value={item.allowed_domains || ''}
                      disabled={isDisabled || isSaving}
                      className='form-control'
                      onChange={handleChange}
                    />
                  </div>

                  {/* Expiration Date */}
                  <div className='mb-4'>
                    <label className='mb-2'>{t('Game expires on')}</label>
                    <input
                      type='date'
                      name='expires_on'
                      value={item.expires_on?.split('T')[0] || ''}
                      disabled={isDisabled || isSaving}
                      className='form-control'
                      onChange={handleChange}
                    />
                  </div>
                </div>
              )}

              {/* Action buttons */}
              <div>
                <div className='form-group'>
                  {/* <label>{t('Session Status')}</label> */}
                  <div className='text-end mt-5'>
                    <button
                      className='btn btn-lg btn-outline-primary'
                      onClick={submit}
                      disabled={isDisabled}>
                      {isSaving ? t('Saving') : t('Save Changes')}
                    </button>
                    <button
                      className={`btn btn-lg btn${
                        isLaunched ? '-' : '-outline-'
                      }success ms-3`}
                      onClick={launch}
                      disabled={isDisabled}>
                      {isLaunched ? t('Launched') : t('Launch')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Panel */}
        <div className='col-7'>
          <div className='form-group'>
            {/* <label className='fs-5'>
              {t('Registered Players')}:{' '}
              {item?.registered ? item?.registered?.length : 0}
            </label> */}

            {item.access_type === 'csv' && (
              <CSVDrop onComplete={readCSV}>
                <div className='input-group input-group-lg mt-2 mb-2'>
                  <textarea
                    name='players_text'
                    className='form-control'
                    placeholder='email@example.com'
                    value={item.players_text || ''}
                    onChange={handleChange}
                    rows='15'
                    disabled={isDisabled || isSaving}></textarea>
                </div>
                <small>
                  <b>{t('Tip')}</b>:{' '}
                  {t('You can also drag and drop your csv file here.')}
                </small>
              </CSVDrop>
            )}

            {item.access_type === 'link' && (
              <div className='card shadow'>
                <div className='card-body p-4'>
                  <PlayersManager disabled={isDisabled} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { Form as GameForm };
